import { Modal, Col, Row, Form, Button, Input, InputRef } from "antd";
import { useTranslation } from "react-i18next";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useContext, useEffect, useRef, Dispatch } from "react";
import { PrintContext } from "../../MainFour";
import { setOpenProceed } from "../ProceedPayment/proceedpayment";
import { useDispatch } from "react-redux";
import { mainActions } from "../../../../store/main/mainSlice";
import { getIsPrintReceipt } from "../../../../utils/main-utils";

interface ConfirmModall {
  isOpenConfirm: boolean;
  setisOpenConfirm: React.Dispatch<React.SetStateAction<boolean>>;
  handlePay: any;
  setIsPayOpen: any;
  setTenderedUSD: any;
  setTenderedLBP: any;
  setReturnedUSD: any;
  setReturnedLBP: any;
  setOverpaymentUSD: any;
}
const ConfirmModal = ({
  isOpenConfirm,
  setisOpenConfirm,
  handlePay,
  setIsPayOpen,
  setTenderedUSD,
  setTenderedLBP,
  setReturnedUSD,
  setReturnedLBP,
  setOverpaymentUSD
}: ConfirmModall) => {
  const [t] = useTranslation("common");
  const submitInput = useRef<InputRef>(null);
  const handlePrint = useContext(PrintContext);
  const setIsProceedOpen = useContext(setOpenProceed);
  useEffect(() => {
    setTimeout(() => {
      submitInput?.current?.focus();
    }, 0);
  });
  const dispatch = useDispatch();
  return (
    <>
      <Modal
        closable={false}
        maskClosable={false}
        onCancel={() => setisOpenConfirm(false)}
        open={isOpenConfirm}
        centered
        okText={`${t("confirm")}`}
        cancelText={`${t("cancel")}`}
        okButtonProps={{
          style: { height: "40px" },
          htmlType: "submit",
          form: "confirmPay",
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            marginInlineEnd: "auto",
            height: "40px",
          },
        }}
        onOk={() => {
          handlePay().then(() => {
            dispatch(
              mainActions.setInvoiceType({
                id: null,
                typeName: null,
                isActive: null
              })
            )
            dispatch(
              mainActions.addDelivery({
                deliveryCharge: null,
                deliveryLocation: {
                  id: null,
                  location: null
                },
                deliveryChargeText: null
              })
            )
            if (getIsPrintReceipt()) {
              handlePrint();
            } else {
              setTenderedUSD("");
              setTenderedLBP("");
              setReturnedUSD("");
              setReturnedLBP("");
              setOverpaymentUSD("");
              setIsPayOpen(false);
              dispatch(mainActions.clearInvoice());
            }
            setisOpenConfirm(false);
            setIsProceedOpen(false);
          });
        }}
      >
        <Form id="confirmPay">
          <Row>
            <Col span={3}>
              <ExclamationCircleFilled
                style={{
                  color: "#FFBC39",
                  fontSize: "45px",
                  marginTop: "22px",
                }}
              />
            </Col>

            <Col span={19}>
              <Col
                style={{
                  fontSize: "32px",
                  color: "#212121",
                }}
              >
                {" "}
                {t("confirm-payment")}
              </Col>
              <Col
                span={19}
                style={{
                  fontSize: "16px",
                  color: "#212121",
                  wordWrap: "break-word",
                }}
              >
                {t("please-confirm-payment-proceedure")}
              </Col>
              {/* <div style={{ display: "hidden" }}> */}
              <Form.Item name="amount" id="amount" noStyle>
                <Input
                  ref={submitInput}
                  autoComplete="off"
                  style={{ opacity: 0, zIndex: -1, position: "absolute" }}
                />
              </Form.Item>
              {/* </div> */}
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
export default ConfirmModal;
